import React, { FunctionComponent } from 'react';
import { MDXRemote } from 'next-mdx-remote';
import type { MarkdownField } from '@modules/utilities/types';

interface MDXMarkdownProps {
  children: MarkdownField;
}

/**
 * NOTE - on the `lazy` prop:
 *
 * While the `lazy` prop provided by this component sounds like a perfect &
 * simple optimization to our use case, it actually causes unexpected styling
 * problem, read more in: https://github.rbx.com/Roblox/doc-site/pull/94
 */
const MDXMarkdown: FunctionComponent<MDXMarkdownProps> = ({ children }) => (
  <MDXRemote {...children} />
);

export default MDXMarkdown;
